import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-black border border-gray-200 shadow-lg",
          description: "text-gray-600",
          actionButton:
            "bg-black text-white",
          cancelButton:
            "bg-gray-100 text-gray-600",
          success: "bg-white text-black border-green-200",
          error: "bg-white text-black border-red-200",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
